import { c as _c } from "react/compiler-runtime";
import { Heading, Dialog } from '@chakra-ui/react';
import { UserSignupEmailCaptureForm } from '@src/components/sco/Account/UserSignupEmailCaptureForm';
import React from 'react';
export const UserSearchBuilderSignupModal = props => {
  const $ = _c(10);
  let t0;
  if ($[0] !== props) {
    t0 = t1 => {
      const {
        open
      } = t1;
      if (!open) {
        props.onDismiss();
      }
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Dialog.Backdrop />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Heading marginBottom={6}>Register to See Matches</Heading>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      background: "transparent",
      boxShadow: "none",
      padding: 0,
      border: "none"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props.onSuccess) {
    t4 = <Dialog.Positioner><Dialog.Content bgColor="colorPalette.container" padding={8}>{t2}<UserSignupEmailCaptureForm afterSuccess={props.onSuccess} containerProps={t3} /></Dialog.Content></Dialog.Positioner>;
    $[5] = props.onSuccess;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t0 || $[8] !== t4) {
    t5 = <Dialog.Root open={true} onOpenChange={t0}>{t1}{t4}</Dialog.Root>;
    $[7] = t0;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};